import ServicePage from '@/pages/services/ServicePage';

const content = {
  eyebrow: 'ACOMA Agents',
  title: 'Agentes de IA que trabajan con tus procesos reales.',
  subtitle:
    'Los agentes de ACOMA se conectan con las herramientas que tu empresa ya utiliza, consultan información y ejecutan tareas dentro de procesos reales.',
  tags: ['Comercial', 'ERP', 'Soporte', 'Operacional', 'Integraciones', 'Automatización'],
  blocks: [
    {
      icon: 'ri-team-line',
      title: 'Agente Comercial',
      desc: 'Automatiza la prospección y el seguimiento de oportunidades.',
      items: ['Prospección', 'Seguimiento', 'Generación de propuestas', 'CRM'],
    },
    {
      icon: 'ri-database-2-line',
      title: 'Agente ERP',
      desc: 'Consulta información de tus sistemas empresariales en tiempo real.',
      items: ['Consultar clientes', 'Stock', 'Pedidos', 'Documentos', 'Indicadores'],
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Agente de Soporte',
      desc: 'Responde consultas y clasifica solicitudes automáticamente.',
      items: ['Responder consultas', 'Buscar documentación', 'Clasificar solicitudes', 'Escalar casos'],
    },
    {
      icon: 'ri-radar-line',
      title: 'Agente Operacional',
      desc: 'Monitorea procesos y detecta anomalías antes de que se conviertan en problemas.',
      items: ['Monitorear procesos', 'Detectar anomalías', 'Generar alertas', 'Ejecutar automatizaciones'],
    },
    {
      icon: 'ri-shield-keyhole-line',
      title: 'Conectado a tus sistemas',
      desc: 'Cada agente se integra con ERP, CRM, APIs y bases de datos para ejecutar acciones reales.',
    },
    {
      icon: 'ri-dashboard-line',
      title: 'Administración centralizada',
      desc: 'Próximamente podrás crear, monitorear y administrar los agentes de tu empresa directamente desde ACOMA.',
    },
  ],
  highlightTitle: 'Portal ACOMA — próximamente',
  highlightDesc:
    'Estamos construyendo un portal donde las empresas podrán contratar y administrar sus propios agentes de IA: organizaciones, usuarios, integraciones, consumo y planes.',
};

export default function AgentesIa() {
  return <ServicePage content={content} />;
}